<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Cascading Scheme" subTitle="List" />

    <ListCascadingScheme />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListCascadingScheme from "@/components/Pages/Management/CascadingScheme/ListCascadingScheme.vue";

export default defineComponent({
  name: "ListCascadingSchemePage",
  components: {
    PageTitle,
    ListCascadingScheme,
  },
});
</script>
